import { DEFAULT_BATCH_DELAY } from '../constants/uiConfig'

export interface UiConfig {
  batchProcessBlockingDelay: number
  documentRequiresLocation: string[]
  autoAddingAddons: string[]
  separateCoupon: string[]
  allowCheckIn: string[]
  closedDepartures: number[]
  denyOvernight: string[]
  allowEl: string[]
  allowIMO: string[]
}

export const composeUiConfig = (data: any) => {
  if (!data) {
    return null
  }
  return {
    batchProcessBlockingDelay: data.batchProcessBlockingDelay ? +data.batchProcessBlockingDelay : DEFAULT_BATCH_DELAY,
    documentRequiresLocation: data.documentRequiresLocation || [],
    autoAddingAddons: data.autoAddingAddons || [],
    separateCoupon: data.separateCoupon || [],
    allowCheckIn: data.allowCheckIn || [],
    closedDepartures: data.closedDepartures || [],
    denyOvernight: data.denyOvernight || [],
    allowEl: data.allowEl || [],
    allowIMO: data.allowIMO || [],
  }
}
